export default __webpack_public_path__ + "static/media/null.a18ec41e.jpg";